// How a discrepancy count reads, wherever it is shown — table cell or detail meta bar.
export const DISCREPANCY_CAP = 3;

export const discrepancyLabel = (t, count) => {
  if (!count) return t('DISCREPANCIES_NONE');
  if (count > DISCREPANCY_CAP) return t('DISCREPANCIES_CAPPED', { cap: DISCREPANCY_CAP });
  if (count === 1) return t('DISCREPANCIES_FOUND_ONE');
  return t('DISCREPANCIES_FOUND', { count });
};
